import { render, staticRenderFns } from "./GradingSettingList.vue?vue&type=template&id=790e06c8"
import script from "../../controllers/grading_setting/grading-setting-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/grading_setting/grading-setting-list.js?vue&type=script&lang=js&external"
import style0 from "./GradingSettingList.vue?vue&type=style&index=0&id=790e06c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports